import { AppAlert } from './AppAlert';

export class Server {    

    public static async deleteJson(url: string, token: string, body?: string) {
        return await Server.fetch(url, "delete", token, body);
    }

    public static async postJson(url: string, token: string, body?: string, getFile: boolean = false) {
        return await Server.fetch(url, "post", token, body, getFile);
    }

    public static async putJson(url: string, token:string, body?: string) {
        return await Server.fetch(url, "put", token, body);
    }

    public static async getJson(url: string, token: string) {
        return await Server.fetch(url, "get", token);
    }

    private static async fetch(url: string, method: string, token: string, body?: string, getFile: boolean = false) {

        const handleAlert = (msg: any) => {
            try {
                const data = msg.json();
                data.then((status: any) => {
                    const userMessage = status.error + ". "; // + (status.details !== null ? "<div title='" + status.details + "'>...</div>" : "");
                    AppAlert.Error(userMessage);
                });
            } catch {
                AppAlert.Error("Oops something went wrong. :-( Unfortunately we don't have enough data to figure out why.")
            }
        }

        const headers = {
            "Content-Type": "application/json",            
            Authorization: `Bearer ${token}`,
            "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload"
        };

        return await fetch(url, {
            method,
            headers: headers,
            body
        })
            .then(res => {
                if (res.ok) {
                    return getFile ? res.blob() : res.json();
                } else {
                    let err = `Something went wrong(Status: ${res.status})`;
                    if (res.status === 403) {
                        err = "Sorry, you don't have permission to perform this action.";
                        AppAlert.Error(err);
                    } else if (res.status === 404) {
                        err = "Sorry, the resource you're trying to access cannot be found.";
                        AppAlert.Error(err);
                    } else {
                        handleAlert(res);
                    }
                    throw new Error(err);
                }
            });
            //.catch(res => null);
    }

    
}